__webpack_require__.p = "/x-rapid/";